import { Badge, Select, message } from "antd";
import React, { useEffect, useState } from "react";
import { apiCall } from "../../utils/Api";
export default function CategorySelector(props) {

    const { onChange = () => { }, value = [], disabled = false } = props;
    const [categories, setCategories] = useState([])

    const listCategories = () => {
        apiCall("events/v2/listCategory", {}, (_status, _result) => {
            if (_status) {
                setCategories(_result);
            } else {
                message.error(_result.error)
            }
        })
    }

    useEffect(() => {
        listCategories()
    }, [])

    const flatCats = (_arr) => {
        return _arr.map(item => item.id);
    }

    const mapCats = (_arr = []) => {
        return _arr.map(item => {
            return { id: item }
        })
    }


    return (
        <>
            <Select disabled={disabled} mode="multiple" dropdownRender={menu => (
                <>
                    {menu}
                </>
            )}
                value={flatCats(value)} allowClear style={{ width: "100%" }} onChange={(e) => onChange(mapCats(e))} placeholder="Select categories">

                {categories.map(item => {
                    return (<Select.Option key={item.key} value={item.id} ><Badge style={{ "backgroundColor": item.colour, "boxShadow": "none" }} dot />  &nbsp; {item.name} </Select.Option>)
                })}
            </Select>
        </>
    )

}